export const PLACEHOLDER_IMAGE_SRC =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

export const MediaVariants = {
  HUGE: {
    height: 4320,
  },
  LARGE: {
    height: 1024,
  },
  LARGE_CROPPED_WITH_BACKGROUND_REMOVED: {
    height: 1024,
    smartCrop: true,
    removeBg: true,
  },
  MEDIUM: {
    height: 512,
  },
  MEDIUM_CROPPED_WITH_BACKGROUND_REMOVED: {
    height: 512,
    smartCrop: true,
    removeBg: true,
  },
  THUMBNAIL: {
    height: 128,
    quality: 55,
    outputFps: 2,
  },
  THUMBNAIL_CROPPED_WITH_BACKGROUND_REMOVED: {
    height: 128,
    quality: 55,
    outputFps: 2,
    smartCrop: true,
    removeBg: true,
  },
};

export const THUMBNAIL_SIZE = {
  height: "128px",
  width: "96px",
};

export enum ENLARGED_SCALE_LEVELS {
  MIN = 1,
  MAX = 3,
  TRIGGER_CLOSE = 0.8,
}

export const ENLARGED_PADDINGS = 100;

export enum ProductMediaPerspective {
  Front = "front",
  FrontFull = "front full",
  FrontAngled = "front angled",
  Back = "back",
}

export enum ProductMediaTypes {
  PackShot = "pack shot",
  ModelShot = "model shot",
}
